/**
 * PWA / offline texts (task.md §4.14). The prototype had no offline banner, install guidance, update prompt or
 * unsent-sales list — every string here is NEW (docs/KNOWN_LIMITATIONS.md L26). 'Mbyll' is the prototype's
 * close label.
 */
export const PWA_TEXT = {
  offline: {
    /** NEW — fixed banner while navigator.onLine is false. */
    banner: 'Pa lidhje interneti — shitjet ruhen lokalisht dhe dërgohen kur rikthehet lidhja',
  },
  update: {
    /** NEW — a new service worker took over this page; the old code keeps running until a reload. */
    ready: 'Një version i ri i aplikacionit është gati',
    reload: 'Rifresko',
  },
  install: {
    /** NEW — iOS Safari outside the installed app (push only works when installed). */
    ios: 'Për njoftime dhe punë pa internet, instalo aplikacionin: shtyp Ndaj dhe zgjidh “Shto në ekranin kryesor”.',
    dismiss: 'Mbyll',
  },
  unsent: {
    /** NEW — sales queued on this device that the server has not accepted yet. */
    title: 'Shitje të pa dërguara',
    subtitle: 'Ruajtura pa internet në këtë pajisje · serveri ka përparësi kur ka mospërputhje',
    pending: 'Në pritje të lidhjes',
    rejected: 'Refuzuar nga serveri: ',
    items: (n: number) => n + (n === 1 ? ' artikull' : ' artikuj'),
    retry: 'Ridërgo',
    discard: 'Hiq',
    discardLabel: (when: string) => 'Hiq shitjen e ' + when,
    retryLabel: (when: string) => 'Ridërgo shitjen e ' + when,
  },
} as const;
